import './view-candidate.scss';

import { Box } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  useFetchList,
  useFetchSingleData,
} from 'services/common/react-query-common-service';
import { MASTER_ENDPOINT } from 'utils/Constant';

import CandidateAttachments from './components/CandidateAttachments';
import CandidateContent from './components/CandidateContent';
import CandidateHeader from './components/CandidateHeader';
import CandidateNotes from './components/CandidateNotes';
import CandidateResume from './components/CandidateResume';

const ViewCandidate: React.FC = observer(() => {
  const { viewJobServiceStore } = useStore();
  const location = useLocation();
  const params = useParams();
  const state = location.state;
  const id = params?.candidateId || '';
  const { candidateInfo: initialCandidateInfo } = state?.Params || {};
  const [candidateInfo, setCandidateInfo] = useState<any>(initialCandidateInfo);
  const jobId = state?.Params?.jobId || ''; // Priority: Route Param > Navigation State > Fallback
  const score = state?.Params?.score || ''; // Priority: Route Param > Navigation State > Fallback
  const [activeTab, setActiveTab] = useState(0);

  // Fetch job data using React Query
  const { data: jobData } = useFetchSingleData<any>(
    ['job-posting', jobId, Number(score)],
    '', // Pass empty string to id to handle query params manually in endpoint
    'job-postings/job-queue?score=' +
      Number(score) +
      (jobId ? '&id=' + (jobId as string) : ''),
    {
      enabled: !!jobId,
      refetchOnMount: 'always',
    },
  );

  // Fetch attachments list
  const {
    data: attachmentsResp,
    isLoading: isAttachmentsLoading,
    refetch: refetchAttachments,
  } = useFetchList<any>(
    ['candidate-attachments', id],
    `${String(
      MASTER_ENDPOINT.Candidates,
    )}/attachments/files?candidateId=${String(id)}`,
    {
      enabled: !!id,
      refetchOnMount: 'always',
    },
  );

  const attachments = attachmentsResp?.files || [];

  // Update MobX stores when API data arrives
  useEffect(() => {
    if (jobData?.data?.[0]) {
      viewJobServiceStore.setJobInfo(jobData.data[0]);
    }
  }, [jobData, viewJobServiceStore]);

  return (
    <Box className="view-candidate-container inter-font-family">
      <Box className="candidate-details-section">
        <CandidateHeader
          id={id}
          candidateInfo={candidateInfo}
          attachments={attachments}
          setCandidateInfo={setCandidateInfo}
        />

        <Box className="tabs-navigation">
          {['Overview', 'Notes', 'Attachments'].map((tab, index) => (
            <Box
              key={tab}
              className={`nav-tab ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}>
              {tab}
            </Box>
          ))}
        </Box>

        <Box className="scrollable-content">
          {activeTab === 0 && (
            <CandidateContent candidateInfo={candidateInfo} />
          )}
          {activeTab === 1 && (
            <CandidateNotes candidateInfo={candidateInfo} jobId={jobId} />
          )}
          {activeTab === 2 && (
            <CandidateAttachments
              id={id}
              jobId={jobId}
              attachments={attachments}
              isLoading={isAttachmentsLoading}
              refetchAttachments={refetchAttachments}
            />
          )}
        </Box>
      </Box>

      <Box className="resume-preview-section">
        <CandidateResume candidateInfo={candidateInfo} />
      </Box>
    </Box>
  );
});

export default ViewCandidate;
